/* eslint-disable class-methods-use-this */
import { Service } from "./Service"
import GedApi from "../API/ged"
import UIService from "./UIService"
import i18next from "i18next"

class GedService extends Service {
    private static instance: GedService

    constructor() {
        super()
        // set le nom du service
        this.name = "GedService"
        // ajoute toute les methodes du service au tableau de mapping
        // this.serviceMap = []
        this.serviceMap.push(
            { key: "download", fct: this.download },
            { key: "upload", fct: this.upload },
            { key: "delete", fct: this.delete }
        )
    }

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): GedService {
        if (!this.instance) {
            this.instance = new GedService()
        }
        return this.instance
    }

    /**
     * Download d'un fichier depuis la GED
     * @param id ged
     */
    public async download(id: string): Promise<void> {
        return GedApi.download(id)
    }

    /**
     * Upload d'un fichier vers la GED
     * @param formData data du form contentant le fichier
     * @param progress callback de notification de l'avencement de l'upload
     */
    public async upload(
        formData: FormData,
        progress: (status: { progress: number }) => void,
        pathOption?: string
    ): Promise<any> {
        try {
            const uploaded = await GedApi.upload(formData, progress, pathOption)
            return uploaded
        } catch (err: any) {
            // code d'erreur de type invalide de teléchargement de fichier'
            if (err?.response?.status === 428) {
                UIService.getInstance().showErrorToast(
                    i18next.t("type_invalid"),
                    "GedService"
                )
            }
            // code d'erreur de taille invalide de teléchargement de fichier'
            else if (err?.response?.status === 429) {
                UIService.getInstance().showErrorToast(
                    i18next.t("size_invalid"),
                    "GedService"
                )
            } else {
                UIService.getInstance().showErrorToast(
                    i18next.t("errChangeFile"),
                    "GedService"
                )
            }
        }
    }

    /**
     * Recupère les metadata de la ged en fonction de l'id
     * @param {string} id ged
     * @returns list de metadata ged
     */
    public async getById(id: string): Promise<any> {
        return GedApi.getMeta(id)
    }

    /**
     * Recupère les metadata de la ged en fonction de l'id
     * @param {string} id ged
     * @returns list de metadata ged
     */
    public async getByIds(ids: string[]): Promise<any> {
        return GedApi.getMetas(ids)
    }

    /**
     * List de toute les metadata de la ged
     * @returns list de metadata ged
     */
    public async list(): Promise<any> {
        return GedApi.list()
    }

    /**
     * Supprimer un fichier depuis la GED
     * @param fileId id du fichier
     */
    public async delete(fileId: string): Promise<void> {
        return GedApi.delete(fileId)
    }
}

export default GedService
